<template>
  <div>
    <v-tabs
      color="secondary"
      v-model="tab"
      :height="40"
      grow
      :mobile-break-point="300"
      class="ma-3"
      icons-and-text
    >
      <v-tabs-slider color="#BBCF20"></v-tabs-slider>
      <v-tab
        v-if="showClinicTab || user.mainType == 0 || user.mainType == 1"
        active-class="activated-tab"
        class="rounded-lg rounded-b-0"
      >
        {{ $t('Engenharia clinica') }}
        <img
          src="../../../../assets/figmaIcons/green/standequip.svg"
          alt="Manual"
          style="object-fit: contain"
          class="ma-1 mr-2"
        />
      </v-tab>
      <v-tab
        v-if="showInfraTab || user.mainType == 0 || user.mainType == 1"
        active-class="activated-tab"
        class="rounded-lg rounded-b-0"
      >
        {{ $t('Engenharia de infraestrutura') }}
        <img
          src="../../../../assets/figmaIcons/green/standequip.svg"
          alt="Manual"
          style="object-fit: contain"
          class="ma-1 mr-2"
        />
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-if="showClinicTab || user.mainType < 2">
        <EquipmentManual :engType="0" ref="clinic" />
      </v-tab-item>
      <v-tab-item v-if="showInfraTab || user.mainType < 2">
        <EquipmentManual :engType="1" ref="infra" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import EquipmentManual from './equipmentManual.vue'

export default {
  name: 'ManualTabs',

  components: { EquipmentManual },

  data() {
    return {
      tab: 0,
      user: {},
      institution: {},
    }
  },

  computed: {
    showClinicTab() {
      const types = this.institution?.departmentTypes || []
      return this.institution?.showManuais && types.includes(0)
    },
    showInfraTab() {
      const types = this.institution?.departmentTypes || []
      return this.institution?.showManuais && types.includes(1)
    },
  },

  watch: {
    tab(newVal) {
      const isClinicFirst = this.showClinicTab || this.user.mainType < 2
      if (newVal === 0 && isClinicFirst && this.$refs.clinic) {
        this.$refs.clinic.loadData?.()
      } else if (this.$refs.infra) {
        this.$refs.infra.loadData?.()
      }
    },
  },

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.user = JSON.parse(localStorage.getItem('user'))
  },
}
</script>
